import { useCallback } from "react";
// eslint-disable-next-line no-restricted-imports -- useStateAwareNavigate wraps react-router-dom's useNavigate directly
import { NavigateOptions, To, useNavigate } from "react-router-dom";
import { usePersistedLocationState } from "./usePersistedLocationState";

/** `navigate` that keeps the scope in location state; a number moves through history like `navigate(-1)`. */
export function useStateAwareNavigate() {
    const navigate = useNavigate();
    const persistedLocationState = usePersistedLocationState();

    return useCallback(
        (to: To | number, options?: NavigateOptions) => {
            if (typeof to === "number") {
                navigate(to);
                return;
            }
            navigate(to, {
                ...options,
                state: {
                    ...persistedLocationState,
                    ...options?.state,
                },
            });
        },
        [navigate, persistedLocationState],
    );
}
